import {
  CrashSeverity,
  StopControlRampTerminal,
  TurnControlType,
} from "../SPFConstants";
import { getpEx } from "./rampCMFHelper";

export const getCMF20 = ({
  aadten,
  aadtex,
  aadtin,
  aadtout,
  crashSeverity,
  exitRampSkewAngle: Isk,
  exitRampApproachRightTurnControlType,
}: StopControlRampTerminal) => {
  if (crashSeverity === CrashSeverity.PDO) {
    throw new Error(
      `Cannot use CMF 20 if crash severity type is not FATAL_INJURY`
    );
  }

  if (
    exitRampApproachRightTurnControlType === TurnControlType.STOP ||
    exitRampApproachRightTurnControlType === TurnControlType.YIELD
  ) {
    const pEx = getpEx({ aadtin, aadtout, aadtex, aadten });
    const DEGREES_IN_ONE_RADIAN = 57.2957795;
    return (
      (1 - pEx) * 1 +
      pEx *
        Math.exp(0.341 * Math.sin(Isk / DEGREES_IN_ONE_RADIAN) * 0.001 * aadtex)
    );
  }
  return 1;
};
